module.exports = __webpack_public_path__ + "img/24.problem_fluid_taps.e6cbddd9.svg";